<template>
    <!-- 详情 -->
    <el-drawer title="我是标题" :visible.sync="drawer" custom-class="my-el-drawer" :with-header="false" size='60%'>
        <div class="my-el-drawer-body">
            <el-row type="flex" class="app-main-header mg-b15" align="middle">
                <el-col :span="6">
                    <div class="router-title">
                        <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{ $route.meta.title }}预览</span>
                    </div>
                </el-col>
                <el-col :span="18" class="app-main-header-btns">
                    <el-button type="primary" size="small" @click="handleEdit(form)" v-hasPermi="['gys:supplierInfo:edit']">编辑 </el-button>
                </el-col>
            </el-row>
            <el-collapse v-model="activeNames">
                <el-collapse-item name="1">
                    <template slot="title">
                        <div style="display: flex;align-items: center;">
                            <el-divider direction="vertical"></el-divider>
                            <span>供应商基本信息</span>
                        </div>
                    </template>
                    <el-card shadow="hover" style="border: none;">
                        <el-descriptions :column="2" :border="false" :colon="false">
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="创建时间">
                            {{ form.createTime }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="创建人">
                            {{ form.createUser }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="企业名称">
                            {{ form.name }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="认证地区">
                            {{ form.rzRegion }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="统一社会信息代码">
                            {{ form.tyShXxCode }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="英文名称">
                            {{ form.englishName }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="企业简称">
                            {{ form.qyShort }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="组织机构代码">
                            {{ form.orgJgCode }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="邓白氏编码">
                            {{ form.dbsCode }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="企业类型">
                            {{ form.qyTyoe }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="纳税人标识">
                            {{ form.taxpayerSign }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="注册国家/地区">
                            {{ form.country }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="详细地址">
                            {{ form.address }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="法定代表人">
                            {{ form.legalPerson }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="注册资本">
                            {{ form.zcCapital }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="注册资本货币种类(万)">
                            {{ form.zcCurrency }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="建立日期">
                            {{ form.foundDate }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="经营范围">
                            {{ form.manageArea }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="营业执照图附件(以上是登记信息)">
                            {{ form.yyZzSrc }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="主要身份">
                            {{ form.zySf }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="经营性质">
                            {{ form.jyXz }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="行业类型">
                            {{ form.hyType }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="主营品类">
                            {{ form.zyClass }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="送货服务范围">
                            {{ form.shFwScope }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="公司官网">
                            {{ form.gsGw }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="公司Logo">
                            {{ form.gsLogoSrc }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="公司简介(以上是业务信息)">
                            {{ form.gsDetail }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="发票头">
                            {{ form.invoiceHead }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="税务登记号">
                            {{ form.swDjh }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="开户行">
                            {{ form.khhName }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="开户行账号">
                            {{ form.khhNumber }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="税务登记地址">
                            {{ form.swDjDz }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="税务登记电话">
                            {{ form.swDjDh }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="收票人邮箱">
                            {{ form.sprEmail }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="收票人电话(以上是开票信息)">
                            {{ form.sprDh }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="企业性质">
                            {{ form.qyXz }}
                            </el-descriptions-item>
                            <el-descriptions-item contentClassName="my-descriptions-conten"
                                                labelClassName="my-descriptions-label" label="状态0启用1停用">
                            {{ form.status }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </el-collapse-item>
            </el-collapse>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data(){
        return {
            activeNames: ['1'],
            drawer: false,
            form:{}
        }
    },
    methods:{
        handleEdit(info){
            this.$emit('callback',{type:1,form:info})
        },
    }
}
</script>
